export class PolicyDevice {

    constructor(
      public Id: string,
      public Name: string,
      public Memory: string,
      public Color: string,
      public Description: string,
      public Model: string,
      public Imei: number,
      public Make: number,
      public SkuNumber: number,
      public SerialNumber: number,
      public RiskTypeCode: number,
      public RiskTypeDescription: number,
      public ClassCode: number,
      public TypeCode: number,
    ) {}
}
